import React, {useEffect, useState} from "react";
import {
  Button,
  Checkbox,
  Container,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import {
  AssignmentRounded,
  CheckBox,
  DirectionsCarRounded,
  ListRounded,
} from "@material-ui/icons";
import BaseModal, {BaseModalActions, BaseModalContent} from "../BaseModal";
import PermitContent from "../../Pages/PermitContent";
import {useSelector} from "react-redux";
import moment from "moment";
import {RouteService} from "../../../services/route.service";
import {getCustomer} from "../../../store/home/selector";
import {useHistory} from "react-router";

const useStyles = makeStyles((theme) => ({
  vehicleDiv: {
    justifyContent: "center",
  },
  activeVehicleRow: {
    background: "gray",
  },
  vehicleRow: {
    padding: "1px",
  },
  thirdStepFirstDivChild: {
    padding: "4px",
  },
  thirdStepFirstDiv: {
    border: "1px solid black",
    background: "gray",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "200px",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    borderRadius: "5px",
  },
  customButton: {
    borderRadius: "10px",
    backgroundColor: "#20419a",
    color: "white",
  },
  customButtons: {
    borderRadius: "10px",
  },
  mleft: {
    marginLeft: "10px",
  },
  headinText: {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
}));

export default function PermitAddedModel(
  {
    open,
    onClose,
    handleToggleAddPermitPage,
    StylingItem,
    selectedDate,
    d,
  }) {
  const classes = useStyles();

  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };

  const validEndDate = (endDate, validDate) => {
    const isAfter = moment(selectedDate).add(validDate, 'days').isAfter(endDate);
    if (!selectedDate) {
      return moment(endDate)?.format("MM/DD/YYYY")
    } else if (isAfter === false) {
      return moment(selectedDate).add(validDate, 'days')?.format("MM/DD/YYYY")
    } else {
      return moment(endDate)?.format("MM/DD/YYYY")
    }
  }

  return (
    <BaseModal
      title="Permit Added"
      align="center"
      open={open}
      icon={<AssignmentRounded/>}
      fullWidth
      style={stylingVal && stylingVal}
    >
      <BaseModalContent>
        <>
          <div className="d-flex contentwrapper">
            <PermitContent permit={d}/>
            <div className="text-left">
              <div>
                <p className={classes.headinText}>
                  {`${d?.name}`} &nbsp; &nbsp;
                </p>
              </div>
              <p>
                Good from{" "}
                {moment(selectedDate ? selectedDate : d?.validStartDate)?.format("MM/DD/YYYY")}{" "}
                to{" "} {validEndDate(d?.validEndDate, d?.validDays)}
              </p>
              <p>${d && d?.price?.toFixed(2)}</p>
              <p>{d?.allowedNoVehicles} Vehicle Limit</p>
            </div>
          </div>
        </>

        <div className="ddflex g40" style={{marginTop: 10}}>
          <Button
            variant={"outlined"}
            className={classes.customButtons}
            onClick={(e) => handleToggleAddPermitPage("view")}
          >
            View cart
          </Button>
        </div>
      </BaseModalContent>
    </BaseModal>
  );
}
